import { render, staticRenderFns } from "./BaskoNextGenFooter.vue?vue&type=template&id=689f2ec4&scoped=true&"
import script from "./BaskoNextGenFooter.vue?vue&type=script&lang=js&"
export * from "./BaskoNextGenFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689f2ec4",
  null
  
)

export default component.exports